// extracted by mini-css-extract-plugin
export var redDark = "od8q2";
export var snooze = "Fmuck";